import { Routes } from '@angular/router';

export const ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('./content/pages/pages.routes').then(m => m.PAGES_ROUTE),
  },
  {
    path: '**',
    redirectTo: '404',
    pathMatch: 'full',
    data: { title: 'Page Not Found' },
  },
];
